'use strict'
// import { message } from 'ant-design-vue'
import store from '@/store/index'
export default {
  init({ id, playerOptions, noticeId, user }, proxy) {
    window.Mudu.Init(id, () => {
      const muduRoom = window.Mudu.Room
      const noticeEle = document.getElementById(noticeId)

      //set Notice
      if (noticeEle) {
        this.setNotice(noticeEle, proxy)
      }

      //get lucky
      this.getLuckyDraw()

      // 获取评论
      var topicPage = muduRoom.Topic.GetPage()
      this.getAllTopic(topicPage, 1, proxy)
      console.log('总页数', topicPage)
      // 返回直播状态，类型为number: `1`为正在直播，`0`为不在直播
      // 当频道为多流频道时，返回主流画面的直播状态
      var roomLiveStatus = window.Mudu.Room.GetLiveStatus()
      proxy.$bus.emit('live.StreamEvent', {
        event: roomLiveStatus
      })
      //直播状态
      window.Mudu.MsgBus.On(
        // 事件名，值为Room.StreamEvent
        'Room.StreamEvent',
        // 事件处理函数，参数类型为object
        (data) => {
          data = JSON.parse(data)
          console.log("/1 ? '开始直播' : '停止直播';")
          //1 ? '开始直播' : '停止直播';
          proxy.$bus.emit('live.StreamEvent', data)
          // proxy.$bus.emit('mudu.Room.StreamEvent', this.setPlayer)
        }
      )
      //抽奖配置变更
      muduRoom.LuckyDraw.On('LuckyDraw.ConfigChange', (msg) => {
        const config = JSON.parse(msg).data
        proxy.$bus.emit('LuckyDraw.ConfigChange', config)
      })

      //抽奖结果
      window.Mudu.MsgBus.On(
        // 事件名，值为LuckyDraw.Open
        'LuckyDraw.Open',

        // 事件处理函数
        (response) => {
          console.log("console.log('开奖啦');")
          response = JSON.parse(response)
          console.log('开奖啦', response)
          if (response.status === 'y') {
            proxy.$bus.emit('LuckyDraw.Winning', response.data)
          }
        }
      )

      //新评论
      window.Mudu.MsgBus.On(
        // 事件名，值为Topic.New
        'Topic.New',

        // 事件处理函数，参数为新的评论，类型为object
        (newTopic) => {
          newTopic = JSON.parse(newTopic) // newTopic 结构见页面底部
          console.log(newTopic)
          proxy.$bus.emit('ChatRoom.NewTopic', newTopic)
        }
      )
      //修改置顶评论
      window.Mudu.MsgBus.On(
        // 事件名，值为Topic.Top
        'Topic.Top',

        // 事件处理函数，参数为新的评论，类型为object
        (newTopic) => {
          newTopic = JSON.parse(newTopic) // newTopic 结构见页面底部
          console.log('一条评论被' + (newTopic.top === 1 ? '置顶' : '取消置顶') + '了')
          proxy.$bus.emit('ChatRoom.TopicTop', newTopic)
        }
      )
      //新的回复
      window.Mudu.MsgBus.On(
        // 事件名，值为Topic.Reply.New
        'Topic.Reply.New',

        // 事件处理函数，参数为新收到的reply
        function (reply) {
          reply = JSON.parse(reply)
          console.log(reply)
          proxy.$bus.emit('ChatRoom.Topic.Reply.New', reply)
        }
      )
      //Player.Ready事件会在播放器初始化完成被触发
      window.Mudu.MsgBus.On(
        // 事件名，值为Player.Ready
        'Player.Ready',

        // 事件处理函数，参数为当前player组件对象
        function (player) {
          console.log('Mudu Player 播放器初始化完成')
          player.setMute(true)
          player.play()
          proxy.$bus.emit('live.playerInit', player)
          document.querySelector('.mudu-icon-play').addEventListener('click', () => {
            window._gsq.push(['track', 'Live_Play', { page_name: '直播间页', button_name: '播放' }])
          })
        }
      )
      //Player.Ready事件会在播放器初始化完成被触发
      window.Mudu.MsgBus.On(
        // 事件名，值为Player.Ready
        'Player.Error',

        // 事件处理函数，参数为当前player组件对象
        function (player) {
          console.log('Mudu Player 异常', player)
          // player.setMute(true)
          // player.play()
          // proxy.$bus.emit('live.playerInit', player)
          // document.querySelector('.mudu-icon-play').addEventListener('click', () => {
          //   window._gsq.push(['track', 'Live_Play', { page_name: '直播间页', button_name: '播放' }])
          // })
        }
      )
      // console.log('Mudu Web Sdk 初始化成功');
      this.setPlayer(muduRoom.GetLiveStatus(), playerOptions)
      const muduUser = window.Mudu.Room.User.GetUser()
      //初始化用户
      if (user.name) {
        window.Mudu.Room.User.Assign(user.name, '', user.assignId, (newUserInfo) => {
          store.commit('userStore/changeMuduUser', newUserInfo.user)
        })
      } else {
        window.Mudu.Room.User.Assign('visitor' + muduUser.id, '', '', (newUserInfo) => {
          store.commit('userStore/changeMuduUser', newUserInfo.user)
        })
      }
    })
  },
  initPlayer(options) {
    const muduRoom = window.Mudu.Room
    const liveKV = require('@/assets/images/live/liveKV.png')
    const player = new window.Mudu.Player({
      // 必须，播放器容器ID，播放器会被添加到该DOM元素中
      width: '100%',
      height: '100%',
      video_id: muduRoom.GetTrailer().video_id,
      image: muduRoom.GetLiveImage(),
      isLive: !!muduRoom.GetLiveStatus(),
      autoplay: true,
      renderError: () => `<img src="${liveKV}" style="width: 100%;height: 100%" />`,
      ...options
    })
    window.player = player
  },
  setPlayer(status, playerOptions) {
    if (status != '1') {
      let muduBar = document.getElementsByClassName('mudu-reset mudu-bar')[0]
      muduBar && (muduBar.style.display = status == '1' ? 'none' : '')
      let muduTime = document.getElementsByClassName('mudu-reset mudu-time')[0]
      muduTime && (muduTime.style.display = status == '1' ? 'none' : '')
    }
    playerOptions.forEach((options) => {
      this.initPlayer(options)
    })
  },
  setNotice(noticeEle, proxy) {
    window.Mudu.Room.Notice.Get((res) => {
      if (res.errcode === 1000) {
        console.log('获取公告成功，当前公告信息:', res.data)
        let { content, state } = res.data
        if (state === 1 && noticeEle) {
          if (!content) {
            proxy.$bus.emit('changeNotice', false)
          } else {
            proxy.$bus.emit('changeNotice', true)
            noticeEle.innerText = content
          }
        }
      } else {
        console.log('获取公告请求失败')
      }
    })
    window.Mudu.MsgBus.On(
      // 事件名，值为Notice.Change
      'Notice.Change',
      // 事件处理方法，参数为新的公告信息
      (data) => {
        console.log('事件处理方法，参数为新的公告信息')
        if (data.state === 1 && noticeEle) {
          if (data.content) {
            proxy.$bus.emit('changeNotice', true)
            noticeEle.innerText = data.content
          } else {
            proxy.$bus.emit('changeNotice', false)
          }
        }
      }
    )
  },
  getLuckyDraw(cb) {
    window.Mudu.Room.LuckyDraw.Get((response) => {
      response = JSON.parse(response)
      if (response.status === 'y') {
        console.log('获取成功，数据为：', response.data)
        cb && cb(response, true)
      }
      if (response.status === 'n') {
        console.log('获取失败')
        cb && cb(response, false)
      }
    })
  },
  LuckyDrawSignUp({ userName, voucher, custom_voucher, custom_field }, cb) {
    window.Mudu.Room.LuckyDraw.SignUp(
      {
        // 观众名，类型为string, 可选配置
        userName,

        // 抽奖唯一凭证，类型为string，推荐使用手机号作为唯一凭证
        voucher,

        // 如果后台勾选了自定义凭证，请传入该参数，参数类型为：string
        // 如果后台没有勾选了自定义凭证，无需传递custom_voucher参数
        custom_voucher,

        // 如果后台勾选了自定义字段以及必填，请传入该参数，参数类型为：string[],每多勾选一个自定义字段，请在数组里多添加一个值
        // 如果后台未勾选了自定义字段但是都未勾选必填，可以无需传递custom_field参数
        custom_field
      },
      // 回调函数，参数为response
      (response) => {
        response = JSON.parse(response)
        if (response.status === 'y') {
          console.log('抽奖报名成功')
          // message.info(response.info)
          cb && cb(response, true)
        }
        if (response.status === 'n') {
          console.log(response.info || '抽奖报名失败')
          // message.info(response.info)
          cb && cb(response, false)
        }
      }
    )
  },
  topicList: [],
  getTopic(page, proxy) {
    window.Mudu.Room.Topic.Get(
      // 要获取评论的页码，类型为int
      page,
      // 评论获取成功的回调函数，参数为response对象
      (response) => {
        response = JSON.parse(response)

        if (response.status === 'y') {
          proxy.$bus.emit('ChatRoom.GetTopic', {
            page,
            topics: response.topics
          })
          console.log('获取评论成功，数据为：', response.topics)
        }
        if (response.status === 'n') {
          console.log('获取评论失败')
        }
      }
    )
  },
  getAllTopic(pageTotal, page, proxy) {
    if (page <= pageTotal) {
      this.getTopic(page, proxy)
      page++
      this.getAllTopic(pageTotal, page, proxy)
    }
    // if (page === 1) {
    //   proxy.$bus.emit('getTopic', { list: this.topicList, page });
    // }
  },
  sendTopic(topic, proxy) {
    window.Mudu.Room.Topic.SendTopic(
      // 要发送的评论文本，类型为string
      topic,
      // 发送完成的回调函数，参数为response对象
      function (response) {
        response = JSON.parse(response)
        if (response.status === 'y') {
          console.log('发送成功')
          proxy.$bus.emit('ChatRoom.SendTopic', { status: true, response })
        }
        if (response.status === 'n') {
          console.log('发送失败，错误码为：' + response.flag)
          proxy.$bus.emit('ChatRoom.SendTopic', { status: false, response })
        }
      }
    )
  }
}
